import { Dialog, DialogContent, DialogTitle, } from '@mui/material';
import "chart.js/auto";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { ApiCall, getDateAndTime, handleDateChange } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { DateBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
import { AccountSummaryPieChart, SalesSummaryBarChart } from "./DashboardChart";
import StatCard from './StateCard';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { setSubLoading } from '../../Redux/Services/AuthSlice';

const Dashboard = () => {

    //--Inital States--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [formData, setFormData] = useState({
        fromDate: getDateAndTime().date,
        toDate: getDateAndTime().date,

    })
    const [dashboardData, setDashboardData] = useState({});

    //--inital State For Modal---//
    const [openModal, setOpenModal] = useState(false)
    const [neededValueForModal, setNeededValueForModal] = useState('')

    //--handle Clear Functionality--//
    const handleClear = () => {
        setFormData({
            fromDate: getDateAndTime().date,
            toDate: getDateAndTime().date,
        });
        setOpenModal(false)
        setNeededValueForModal('')
    }

   

    //--het DashBoard All Data--//
    const getDashBoardData = async () => {
        await dispatch(setSubLoading(true))
        let DataDoc = await ApiCall('/api/Dashboard/GetDashboardDetails', { ...formData })
        await dispatch(setSubLoading(false))
        if (DataDoc.status === 'UNAUTHORIZED' || DataDoc.status === 'ERROR' || DataDoc.status === 'EXPIRED') {
            await NotificationSound(DataDoc.status, DataDoc.message, DataDoc.focus, inputrefs);
        }
        else {

            setDashboardData(DataDoc.data)
        }

    }

    
    //--Grid Data Fetch Function--//
    const getModalDataGrid = async (CurrentPage, item) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            CallType: item?.keyName ? item?.keyName:'',
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Dashboard/ShowDashboardTotalRecord', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            setResult([])
        }
    }
    //--get Modal Grid Data--//
    const handleChange1 = (event, value) => {
        getModalDataGrid(value, neededValueForModal);
    };
    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleCardModal = (value) => {
  
        setNeededValueForModal(value)
        getModalDataGrid(1,value)
        setOpenModal(true)
    }
    const handleExport = async (value) => {

        let ExportRequest = {
            ...filterData,
            ...sortConfig,
            ...formData,
            Type: 'E',
            PageIndex: '1',
            CallType: neededValueForModal?.keyName ? neededValueForModal?.keyName : '',
        }
        await handleDownloadExcel('/api/Dashboard/ShowDashboardTotalRecord', ExportRequest, neededValueForModal?.keyName)
    }

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        getModalDataGrid(1, neededValueForModal);
    }, [sortConfig]);
    
    useEffect(() => {
        document.title = 'Dashboard'
        getDashBoardData()

    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header py-2'>
                    <h6>Dashboard</h6>
                    <div className='row'>

                        <DateBox
                            inputrefs={inputrefs}
                            label="From Date"
                            placeholder="From Date"
                            id='txtFromDate'
                            preventOpenOnFocus={true}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtToDate'].focus()
                                };
                            }}

                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                        />

                        <DateBox
                            inputrefs={inputrefs}
                            label="To Date"
                            placeholder="To Date"
                            id='txtToDate'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtSearch'].focus()
                                };
                            }}

                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                        />

                        <div className='col-md-3 col-lg-3'>
                            <button type="button"
                                onClick={() => {
                                    getDashBoardData()
                                }}
                                ref={ref => (inputrefs.current[`txtSearch`] = ref)}
                                className="btn btn-rounded text-white btn-success mt-3"
                                style={{ minWidth: '1.5rem', fontSize: '10px' }}
                            >
                                <i className="fa fa-search"></i>
                            </button>

                            <button type="button"
                                id='txtBtn'
                                 onClick={handleClear}
                                className="btn btn-rounded text-white btn-danger mt-3"
                                style={{ minWidth: '1.5rem', fontSize: '10px' }}
                            >
                                <i className="fa-solid fa-arrow-rotate-left text-white "></i>
                            </button>
                        </div>
                    </div>

                </div>

                <div className='container-fluid dashboard'>
                    <div className="dashboard-section card shadow-sm mb-3">
                        <div className="dashboard-section-header">  Pickup Request </div>
                        <div className="card-body">
                            <div className="row">
                                {dashboardData?.pickupRequestList?.map((item, i) => (
                                       <StatCard  key={i}  item={item}   colClass="col-md-3 col-sm-6"  handleClick={handleCardModal}  />
                                ))}
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="dashboard-section card shadow-sm mb-3">
                                <div className="dashboard-section-header">  Booking List </div>
                                <div className="card-body">
                                    <div className="row">
                                        {dashboardData?.bookingList?.map((item, i) => (
                                               <StatCard  key={i}  item={item}    colClass="col-md-3 col-sm-6"  handleClick={handleCardModal}  />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<div className="col-md-6">*/}
                        {/*    <div className="dashboard-section card shadow-sm mb-3">*/}
                        {/*        <div className="dashboard-section-header">  Status List  </div>*/}
                        {/*        <div className="card-body">*/}
                        {/*            <div className="row">*/}
                        {/*                {dashboardData?.statusList?.map((item, i) => (*/}
                        {/*                    <StatCard  key={i}  item={item}  colClass="col-md-6 col-sm-6"  handleClick={handleCardModal}  />*/}
                        {/*                ))}*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>

                    <div className='row mt-2'>
                        <div className='col-lg-6 col-md-6 col-sm-12' >
                            <div className='main-card card  text-center' style={{ border: '1px solid #79A7FB' }}>
                                <div className='card-header mb-1 d-flex justify-content-between align-items-center'>  <h6 className="m-0">Day Wise Booking Report</h6>  </div>
                                <div className='card-body '>
                                    <div style={{ width: '100%', height: '300px' }}>
                                        <SalesSummaryBarChart data={dashboardData.dayWiseBooking}  />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <div className='main-card card text-center' style={{ border: '1px solid #79A7FB' }}>
                                <div className='card-header mb-1 d-flex justify-content-between align-items-center'>
                                    <h6 className="m-0">Pickup Status Report</h6>
                                </div>
                                <div className='card-body'>
                                    <div style={{ width: '100%', height: '300px' }}>
                                        <AccountSummaryPieChart data={dashboardData.pickupStatusReport} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <Dialog
                open={openModal}
                onClose={() => {
                    setOpenModal(false)
                    setResult([])
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-container": {
                        alignItems: "flex-start",
                    },
                    "& .MuiPaper-root": {
                        marginTop: "100px",
                        width: "100%",
                        maxWidth: "900px",
                    }
                }} >
      
             

                <DialogTitle
                    id="alert-dialog-title"
                    className="border-bottom"
                    sx={{ py: 1, px: 2,  display: "flex", alignItems: "center", justifyContent: "space-between", }} >
                    <span style={{ fontSize: "15px", fontWeight: 600 }}>
                        {neededValueForModal.name} Data
                    </span>
                    <div className="d-flex align-items-center gap-2">
                        <button type="button" className="btn btn-sm btn-warning d-flex align-items-center"
                            onClick={() => handleExport(neededValueForModal)} >
                            <i className="fa fa-download me-2 text-white"></i>
                            Export
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-light"
                            title="Close"
                            onClick={() => {
                                setOpenModal(false)
                                setResult([])
                            }}
                            style={{ borderRadius: "50%", width: "32px",  height: "32px", }} >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                </DialogTitle>

                <DialogContent className='main-card px-0 mx-0 my-0 py-1' style={{ boxShadow: 'none' }}>
                    <div className='row px-0 mx-0 pb-1 border-bottom'>
                        <Table
                            PageName={'Dashboard'}
                            loading={loading}
                            handleFilter={() => {
                                getModalDataGrid(1, neededValueForModal)
                                setFilterData({
                                    ...filterData,
                                })
                            }}
                            Filter={false}
                            onlyFilterPage={true}
                            filterData={filterData}
                            tableData={result}
                            setFilterData={setFilterData}
                            currentPageNo={currentPageNo}
                            handleChange1={handleChange1}
                            handleSorting={handleSorting}
                            sortConfig={sortConfig}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
export default Dashboard;
